import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import type { ProdutoStatus, ProdutoTipo } from '../types/enum';
import { ProdutoSchema } from '../types/Produto';

export enum ApiProdutoGetParamsEstoqueTipo {
    ComEstoque = 1,
    SemEstoque = 2,
}

export type ApiProdutoGetParams = Partial<
    DefaultApiParams & {
        nome: string;
        codigo: string;
        sku: string;
        codigo_barra: string;
        estoque_menor: number;
        tipo_fiscal: string[] | string;
        pesquisar: string;
        tabela_preco_idpk: number;
        venda_externa_idpk: number;
        marcadores: string;
        regra_fiscal_idpk: number;
        tipo: ProdutoTipo[];
        categoria_idpk: number;
        marca_idpk: string;
        ncm: string;
        ncm_status: 'P' | 'I' | 'V';
        fornecedor_idpk: number[];
        status: ProdutoStatus;
        estoque_idpk: number[];
        estoque_tipo: ApiProdutoGetParamsEstoqueTipo;
    }
>;

const schema = registrosSchema(ProdutoSchema);

export function apiProdutoGet({ idpk, params }: { idpk?: number; params?: ApiProdutoGetParams }) {
    return fetchApi({
        endpoint: 'Produto/Produto',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const API_PRODUTO_GET_KEY = 'apiProdutoGet';

export function apiProdutoGetQueryOptions({
    idpk,
    params,
}: {
    idpk?: number;
    params?: ApiProdutoGetParams;
}) {
    return queryOptions({
        queryFn: () => apiProdutoGet({ idpk, params }),
        queryKey: [API_PRODUTO_GET_KEY, idpk, params],
    });
}
